export type HighlightPart = { text: string; isMatch: boolean };

export function splitHighlight(
  text: string,
  preTag: string,
  postTag: string,
): HighlightPart[] {
  const parts: HighlightPart[] = [];
  const [before, ...rest] = text.split(preTag);
  if (before) {
    parts.push({ text: before, isMatch: false });
  }
  for (const segment of rest) {
    const [match, ...after] = segment.split(postTag);
    if (match) {
      parts.push({ text: match, isMatch: true });
    }
    const afterText = after.join(postTag);
    if (afterText) {
      parts.push({ text: afterText, isMatch: false });
    }
  }
  return parts;
}
